














































































































































import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, EstadoEntidad } from '@/config/enums';
import config from '@/config/index';
import HandleErrors from '@/config/handleErrors';
import Confirmation from '@/components/Confirmation.vue';
import { ITipoContacto } from '@/interfaces/TipoContacto';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Validator } from 'vee-validate';
import { ComponenteBaseStepper } from '../../views/base/ComponenteBaseStepper';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { EstadoInterface } from '@/interfaces/Estado';
import { EstadosService } from '@/services/estadosService';
@Component({
  components: {
    'app-confirmacion': Confirmation,
  },
})
export default class TipoContactoNuevo extends ComponenteBaseStepper {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: () => ({ id: 0, estado: 0 }) }) tipoContacto!: ITipoContacto;

  //Abstract
  permisosActuales: PermisoAccionVm[] = [];

  informacionGeneral: PermisoAccionVm = {
    accion: 'Crear - Información General',
    visible: true,
    step: 1,
  };

  permisosTotales: PermisoAccionVm[] = [this.informacionGeneral];

  //Variables globales
  $snotify: any;
  e1: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = false;
  validForm: boolean = false;
  dictionaryFormErrors: any = {};
  dialogConfirmacion: boolean = false;
  handleErrors: HandleErrors = new HandleErrors();
  dialogConfirmacionClose: boolean = false;
  axios: AxiosVue = new AxiosVue(ServicioProxy.Contacto);
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  btnBloquear: boolean = false;

  //controllers
  readonly Controller: string = 'TipoContactos';

  //data
  editedItem: ITipoContacto = {};
  warningInactivo: any = '';
  guardarInactivo: boolean = false;
  mensajeConfirmacionInactivo: any = '';
  estado: boolean = true;

  constructor() {
    super();
    this.registrarValidadores();
  }

  mounted() {
    this.initialize();
  }

  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value;
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    this.$validator.reset();
    this.editedItem.estado = EstadoEntidad.Activo;
    this.mensajeConfirmacionInactivo = this.$t('mensajes.crud.crear.mensaje', {
      entidad: 'el Tipo de Contacto',
    });
  }

  continuar() {
    if (this.e1 == 1) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.dialogConfirmacion = true;
          this.btnBloquear = true;
        }
      });
    }
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivCale').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('modalAsociacionEmit', false);
    this.$validator.reset();
    this.dialog = false;
    this.warningInactivo = '';
    this.estado = true;
  }

  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;
    if (val) {
      this.loadingService.showLoading();
      this.editedItem.estado = this.estado === true ? 1 : 0;
      this.axios.http
        .post(`${this.Controller}/`, this.editedItem)
        .then(res => {
          this.$snotify.success(
            this.$t('mensajes.mensajesExito.crear', {
              entidad: 'Tipo de Contacto',
              creadoA: 'creado',
            })
          );
          this.closeModal(false);
          this.loadingService.hideLoading();
        })
        .catch(error => {
          this.loadingService.hideLoading();
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              this.$snotify.error(
                this.$t('mensajes.mensajesError.crear', {
                  entidad: 'el Tipo de Contacto',
                })
              );
            }
          } else {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.crear', {
                entidad: 'el Tipo de Contacto',
              })
            );
          }
        });
    }
    this.btnBloquear = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        nombre: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        descripcion: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }

  selectedEstado(isActivo: boolean) {
    if (!isActivo) {
      this.warningInactivo = this.$t('mensajes.crud.inactivo.mensaje');
      this.guardarInactivo = true;
      this.mensajeConfirmacionInactivo =
        this.warningInactivo +
        ' ' +
        this.$t('mensajes.crud.crear.mensaje', {
          entidad: 'el Tipo de Contacto',
        });
    } else {
      this.warningInactivo = '';
      this.guardarInactivo = false;
      this.mensajeConfirmacionInactivo = this.$t(
        'mensajes.crud.crear.mensaje',
        { entidad: 'el Tipo de Contacto' }
      );
    }
  }

  private registrarValidadores() {
    const self = this;

    Validator.extend('nombreUnico', {
      getMessage(field: any, params: any, data: any) {
        return '* Ya existe un Tipo de Contacto con este nombre.';
      },
      validate(value: any) {
        return self.axios.http
          .get(`${self.Controller}/ChequearNombreUnico/0/${value}`)
          .then(response => {
            return new Promise(resolve => {
              resolve({
                valid: response.data,
                data: response.data
                  ? undefined
                  : {
                      message:
                        '* Ya existe un Tipo de Contacto con este nombre.',
                    },
              });
            });
          })
          .catch(err => {
            return true;
          });
      },
    });
  }
}
